import React from "react";
import styled from "styled-components";
import { CPanel, H2, H4, Caption, Flex } from "@appcues/component-library";
import {
  HISTORICAL_PLAN_LIMITS,
  PLAN_TYPES,
  PLAN_TO_TIER_MAPPINGS
} from "constants/plans";

const YourPlan = props => {
  const { planLimit, planType } = props;

  const planIdentifier = PLAN_TO_TIER_MAPPINGS[planType]
    ? PLAN_TO_TIER_MAPPINGS[planType]
    : planType;

  const plan = PLAN_TYPES.find(
    plan => plan.id === planIdentifier.toLowerCase()
  );

  const mauRange = HISTORICAL_PLAN_LIMITS.find(limit => limit.id === planLimit);

  let mauRangeDisplay;

  if (mauRange) {
    mauRangeDisplay = mauRange.name.includes("-")
      ? mauRange.name.split("-").join("to")
      : mauRange.name;
  }

  const planFeatures = Object.keys(plan.features)
    .filter(feature => plan.features[feature])
    .map(feature => (
      <PlanFeatureBullets key={feature}>{feature}</PlanFeatureBullets>
    ));

  return (
    <CPanel alignItems="flex-start">
      <CPanel.Header>
        <H4 type="secondary">{`Appcues ${plan.name} Plan`}</H4>
      </CPanel.Header>
      {mauRangeDisplay && (
        <Flex alignItems="baseline" marginBottom={12}>
          <H2 type="secondary">
            {mauRangeDisplay === "1 to 2,500" ? "Up to 2,500" : mauRangeDisplay}
          </H2>
          <Caption>&nbsp; monthly active users (MAUs)</Caption>
        </Flex>
      )}
      <PlanFeatureList>{planFeatures}</PlanFeatureList>
    </CPanel>
  );
};

export default YourPlan;

const PlanFeatureList = styled.ul`
  padding-left: 1rem;
`;

const PlanFeatureBullets = styled.li`
  margin-bottom: 4px;
`;
